import React, { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import smartParkService from "../../axios";
import { useSelector } from "react-redux";
import { login_ } from "../../reducers/login";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import "../../assets/scss/App.scss";
import styles from "../../components/components.js";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import { checkPermissions } from "../../utils/checkPermissions.js";
import { Grid } from "@material-ui/core";

import SensorDetailsCard from "./Components/SensorDetailsCard.jsx";
import SensorInforCard from "./Components/SensorInforCard.jsx";

const override = css`
  display: block;
  margin: 250px auto;
  border-color: #0076bb;
`;

const useStyles = makeStyles(styles);

const SensorDetails = () => {
  const classes = useStyles();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const sensor = params.get("sensorId");

  const loginDetails = useSelector(login_);
  const userid = _.get(loginDetails, "UserID", "");

  const [loading, setLoading] = useState(true);

  const [sensorData, setSensorData] = useState({});

  const [paginationData, setPaginationData] = useState({
    total: null,
    limit: 10,
    page: 1,
    pages: 0,
  });

  const fetchData = async ({
    page = paginationData.page,
    limit = paginationData.limit,
    updatePagination = false,
  }) => {
    if (!sensor || !userid) return;
    try {
      setLoading(true);

      const response = await smartParkService.get(
        `api/sensors/dot-sensor/viewdetails/${sensor}?page=${page}&limit=${limit}`,
        {
          headers: {
            userid,
          },
        },
      );

      if (response?.data?.data) {
        const { metadata } = response.data.data;

        setSensorData(response.data.data);
        if (updatePagination) {
          setPaginationData(metadata);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData({ updatePagination: true });
  }, []);

  const paginationHandler = ({ type, params }) => {
    if (!type || !params) return;
    console.log("ssss", params);

    switch (type) {
      case "pageChange":
        fetchData({ page: params.newPage + 1, updatePagination: true });

        break;

      case "limitChange":
        fetchData({ page: 1, limit: params.newLimit, updatePagination: true });

        break;

      default:
        break;
    }
  };

  if (
    !checkPermissions({
      permission: "Configuration",
      permissionType: "read",
    })
  ) {
    return (
      <div
        style={{
          color: "red",
          position: "absolute",
          top: "50%",
          left: "40%",
          fontSize: "20px",
          transform: "translate(-50%, -50%)",
        }}
      >
        You do not have read permissions. Please contact Admin.
      </div>
    );
  }

  if (loading) {
    return (
      <ClipLoader color="#0076bb" loading={loading} css={override} size={60} />
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.contentPage}>
        <section className="content-header">
          <h3 className="float-left">Sensor Information</h3>

          <div className="float-right">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/overview">Home</a>
              </li>

              <li className="breadcrumb-item active">Sensor Configuration</li>
            </ol>
          </div>
        </section>

        <section className="content">
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <SensorDetailsCard data={sensorData} />
            </Grid>

            <Grid item xs={12} md={9}>
              <SensorInforCard
                sensors={sensorData?.readings}
                data={sensorData}
                refreshHandler={fetchData}
                paginationData={paginationData}
                paginationHandler={paginationHandler}
              />
            </Grid>
          </Grid>
        </section>
      </div>
    </div>
  );
};

export default SensorDetails;
